import { TableHeader } from "@/models/TableHeader";

export const facilityFeatureHeaders: TableHeader[] = [
  {
    text: "Category",
    value: "category",
    width: "20rem"
  },
  {
    text: "Feature Text",
    value: "text",
    width: "30rem"
  },
  {
    text: "Icon",
    value: "icon",
    sortable: false,
    width: "8rem"
  },
  {
    text: "Actions...",
    sortable: false,
    value: null,
    width: "8rem"
  }
];
